<template>
    <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition"
            v-model="value"
    >
        <v-card v-if="cardset.api.getLoaded">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ $t('title.editCardset') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save()">
                        <v-icon left>save</v-icon>
                        {{ $t('nav.save') }}
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-container>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field
                                :label="$t('field.name')"
                                v-model="cardset.name"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-textarea
                                :label="$t('field.description')"
                                v-model="cardset.description"
                        ></v-textarea>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <language-input v-model="cardset.lang"></language-input>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <public-input v-model="cardset.public"></public-input>
                    </v-col>
                </v-row>
                <div>
                    {{ message }}
                </div>
            </v-container>
        </v-card>
        <v-container v-else>
            <h2 class="text-center">
                {{ $t('nav.loading') }}
            </h2>
        </v-container>
    </v-dialog>
</template>

<script>
    import LanguageInput from "../widgets/LanguageInput";
    import {Cardset} from "../../models/Cardset";
    import PublicInput from "@/components/widgets/PublicInput";

    export default {
        name: "CardsetEdit",
        components: {PublicInput, LanguageInput},
        data: function () {
            return {
                dialog: false,
                message: '',
                cardset: new Cardset(),
            }
        },
        props: {
            pk: {
                required: true,
                type: Number,
            },
            value: {
                required: true,
                type: Boolean,
            }
        },
        watch: {
            value: function () {
                if (this.value) {
                    this.getDetail();
                }
            },
        },
        methods: {
            save() {
                let that = this;
                this.cardset.api.save().then(function () {
                    // that.message = 'Success!';
                    that.close();
                }).catch(error => {
                    that.message = error;
                })
            },
            cancel() {
                this.message = 'Cancel clicked.';
            },
            close() {
                this.$emit('closed')
            },
            getDetail() {
                this.cardset.api.fetch(this.pk);
            },
        },
    }
</script>

<style scoped>
</style>
